import * as React from 'react';
import { CandidateSuccessScreen } from './CandidateSuccessScreen';
import { withProvider } from '../../redux';
import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';
import { IConfig } from '@cian/config/shared';
import { ApplicationContext } from '../ApplicationContext';
import { CandidateSuccessScreenHomeownerPayment } from './CandidateSuccessScreenHomeownerPayment';

interface ICandidateSuccessScreenContainerProps {
  httpApi: IHttpApi;
  logger: ILogger;
  config: IConfig;
}

export const CandidateSuccessScreenContainer = withProvider(
  ({ httpApi, logger, config }: ICandidateSuccessScreenContainerProps) => {
    const context = { httpApi, logger, config };

    const homeownerSubscriptionPaymentEnabled = Boolean(
      config.get('homeownerSubscriptionPayment.enabled'),
    );

    return (
      <ApplicationContext.Provider value={context}>
        {homeownerSubscriptionPaymentEnabled ? (
          <CandidateSuccessScreenHomeownerPayment />
        ) : (
          <CandidateSuccessScreen />
        )}
      </ApplicationContext.Provider>
    );
  },
);
